const menuData = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: "fa-solid fa-tv",
    path: "/dashboard",
  },
  {
    id: "orders",
    label: "Orders",
    icon: "fa-solid fa-cart-shopping",
    path: "/orders",
  },
  {
    id: "transaction",
    label: "Transaction",
    icon: "fa-solid fa-sack-dollar",
    path: "/transaction",
  },
  {
    id: "customers",
    label: "Customers",
    icon: "fa-solid fa-users",
    path: "/customers",
  },
  {
    id: "menu",
    label: "Menu",
    icon: "fa-solid fa-bars",
    path: "/menu",
  },

  {
    id: "products",
    label: "Products",
    icon: "fa-solid fa-box",
    subMenu: [
      {
        id: "Search",
        label: "Search",
        path: "/search",
      },
      {
        id: "category",
        label: "Category",
        path: "/category",
      },
      {
        id: "draft catalogue",
        label: "Draft Catalogue",
        path: "/darft-catalogue",
      },
    ],
  },

  {
    id: "uploads",
    label: "Uploads",
    icon: "fa-solid fa-file",
    subMenu: [
      {
        id: "Upload Image",
        label: "Upload Image",
        path: "/upload-images",
      },
      {
        id: "Upload Sheet",
        label: "Upload Sheet",
        path: "/upload-sheet",
      },
    ],
  },

  {
    id: "master tables",
    label: "Master Tables",
    icon: "fa-solid fa-cubes-stacked",
    subMenu: [
      { id: "currency", label: "Currency", path: "/currency" },
      { id: "sizes", label: "Sizes", path: "/sizes" },
      { id: "home banners", label: "Home Banners", path: "/home-banner" },
      { id: "page banners", label: "Page Banners", path: "/page-banner" },
      { id: "cms", label: "CMS", path: "/cms" },
      { id: "attributes", label: "Attributes", path: "/attributes" },
      { id: "shipping partners", label: "Shipping Partners", path: "/shipping-partner" },
      { id: "popups", label: "Popups", path: "/popups" },
      { id: "testimonials", label: "Testimonials", path: "/testimonials" },
    ],
  },

  {
    id: "home page",
    label: "Home Page",
    icon: "fa-solid fa-house",
    subMenu: [
      { id: "Collection", label: "Collections", path: "/collections" },
      { id: "Home Section", label: "Home Section", path: "/home-section" },
    ],
  },

  {
    id: "Stitching Group",
    label: "Stitchings",
    icon: "fa-solid fa-scissors",
    path: "/stitching",
  },

  {
    id: "Shipping Zone",
    label: "Shipping Zones",
    icon: "fa-solid fa-truck",
    path: "/shipping-zone",
  },

  {
    id: "inquiry",
    label: "Inquiry",
    icon: "fa-solid fa-comment-dots",
    subMenu: [
      { id: "contacts inquiry", label: "Contacts Inquiry", path: "/contact" },
      { id: "products inquiry", label: "Products Inquiry", path: "/product-inquiry" },
    ],
  },

  {
    id: "newsletter",
    label: "NewsLetter",
    icon: "fa-regular fa-envelope",
    path: "/news-letter",
  },

  {
    id: "settings",
    label: "Settings",
    icon: "fa-solid fa-gear",
    subMenu: [
      { id: "social media", label: "Social Media", path: "/social-media" },
      { id: "email template", label: "Email Template", path: "/email-template" },
      { id: "website settings", label: "Website Settings", path: "/settings" },
      { id: "email configuration", label: "Email Configuration", path: "/email-configuration" },
      { id: "payment methods", label: "Payment Methods", path: "/payment-method" },
      { id: "sitemap", label: "Sitemap", path: "/sitemap" },
    ],
  },

  {
    id: "roles & permissions",
    label: "Roles & Permissions",
    icon: "fa-solid fa-user-shield",
    subMenu: [
      { id: "roles", label: "Roles", path: "/role" },
      { id: "users", label: "Users", path: "/user" },
      { id: "page", label: "Page", path: "/page" },
    ],
  },
];

export default menuData;